import {z} from 'zod/v4';
import {Condition} from '../types/condition';
import {ArrayFilterSchema} from './filter';
import {ReferenceQuerySchema, ReferenceSchema} from './reference';
import {TemplateValueSchema} from './template';
import {GeneratedValueSchema} from './utility';

const ComparisonConditionFields = {
  field: z.lazy(() =>
    z.union([z.string(), GeneratedValueSchema, ReferenceSchema, ReferenceQuerySchema, TemplateValueSchema]),
  ),
  value: z.lazy(() => z.union([z.string(), z.number(), ReferenceSchema])),
};

const LogicalConditionFields = {
  conditions: z.lazy((): z.ZodArray<z.ZodType<Condition>> => z.array(ConditionSchema)),
};

const InConditionFields = {
  field: z.string(),
  value: z.lazy(() => z.array(z.union([z.string(), ReferenceSchema]))),
};

const EmptyConditionFields = {
  fields: z.array(z.string()),
};

const ArrayConditionFields = {
  field: z.lazy(() => z.union([z.string(), ReferenceQuerySchema])),
  value: z.lazy(() => z.union([z.string(), ReferenceSchema])),
};

const ArrayRowsSchema = z.strictObject({
  array: z.string(),
  filters: z.lazy(() => z.array(ArrayFilterSchema)).optional(),
});

const VisibleConditionFields = {
  field: z.string(),
};

const ArrayEqualConditionFields = {
  arrays: z.tuple([ArrayRowsSchema, ArrayRowsSchema]),
  fields: z.array(z.tuple([z.string(), z.string()])),
};

export const ConditionSchema: z.ZodType<Condition> = z.discriminatedUnion('operator', [
  z.strictObject({operator: z.literal('='), ...ComparisonConditionFields}),
  z.strictObject({operator: z.literal('!='), ...ComparisonConditionFields}),
  z.strictObject({operator: z.literal('>'), ...ComparisonConditionFields}),
  z.strictObject({operator: z.literal('>='), ...ComparisonConditionFields}),
  z.strictObject({operator: z.literal('<'), ...ComparisonConditionFields}),
  z.strictObject({operator: z.literal('<='), ...ComparisonConditionFields}),
  z.strictObject({operator: z.literal('and'), ...LogicalConditionFields}),
  z.strictObject({operator: z.literal('or'), ...LogicalConditionFields}),
  z.strictObject({operator: z.literal('not'), ...LogicalConditionFields}),
  z.strictObject({operator: z.literal('in'), ...InConditionFields}),
  z.strictObject({operator: z.literal('not in'), ...InConditionFields}),
  z.strictObject({operator: z.literal('has'), ...ArrayConditionFields}),
  z.strictObject({operator: z.literal('empty'), ...EmptyConditionFields}),
  z.strictObject({operator: z.literal('not empty'), ...EmptyConditionFields}),
  z.strictObject({operator: z.literal('visible'), ...VisibleConditionFields}),
  z.strictObject({operator: z.literal('array equal'), ...ArrayEqualConditionFields}),
]);
